/**
 * Valida se o usuário está próximo das coordenadas especificadas.
 * @param {number} targetLat - Latitude do local desejado.
 * @param {number} targetLng - Longitude do local desejado.
 * @param {number} [radius=50] - Raio permitido em metros (padrão: 50m).
 * @returns {Promise<boolean>} - `true` se estiver dentro do raio, `false` caso contrário.
 * @throws {string} - Mensagem de erro se a geolocalização falhar.
 */
export const validateUserLocation = async (targetLat, targetLng, radius = 50) => {
  if (!navigator.geolocation || !navigator.permissions) {
    throw "Geolocalização não é suportada neste navegador.";
  }

    const permission = await navigator.permissions.query({ name: "geolocation" });
    
      if (permission.state === "denied") {
    throw "Permissão de localização está bloqueada permanentemente. Vá nas configurações do navegador para permitir.";
  }


  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;
        const distance = calculateDistance(userLat, userLng, targetLat, targetLng);
        resolve(distance <= radius);
      },
      (error) => {
        const errorMessages = {
          1: "Permissão de localização negada pelo usuário.",
          2: "Localização indisponível (GPS desligado?).",
          3: "Tempo de solicitação excedido.",
        };
        reject(errorMessages[error.code] || "Erro desconhecido ao obter localização.");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });
};

// Calcula a distância entre duas coordenadas (Fórmula de Haversine)
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371e3; // Raio da Terra em metros
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distância em metros
}